__turbopack_context__.v({
  "active": "styles-module__1nQbma__active",
  "icon": "styles-module__1nQbma__icon",
  "sublink": "styles-module__1nQbma__sublink",
  "text": "styles-module__1nQbma__text",
});
